/* Maharaja Super — endless product rows.
   Turns a Dawn product slider (<ul data-mx-loop>) into an infinite loop:
   when the row reaches an end, cards are moved from the other end so it
   never stops. Optional auto-advance pauses on hover, touch, when the tab
   is hidden or the row is off screen, and for reduced-motion users. */
(function () {
  if (window.MxLoopInit) return;
  window.MxLoopInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ANIM_MS = 520;

  function items(list) {
    return Array.prototype.filter.call(list.children, function (el) {
      return el.tagName === 'LI';
    });
  }

  function stepWidth(list) {
    var li = items(list);
    if (li.length < 2) return li[0] ? li[0].offsetWidth : 0;
    return li[1].offsetLeft - li[0].offsetLeft;
  }

  function maxLeft(list) {
    return list.scrollWidth - list.clientWidth;
  }

  function setLeft(list, value) {
    list.style.scrollBehavior = 'auto';
    list.scrollLeft = value;
    void list.offsetWidth;
    list.style.scrollBehavior = '';
  }

  function Loop(list) {
    this.list = list;
    this.root = list.closest('slider-component') || list.parentElement;
    this.seconds = parseFloat(list.dataset.mxLoop || '0');
    this.busy = false;
    this.paused = false;
    this.timer = null;
    this.bind();
  }

  Loop.prototype.rotateForward = function () {
    var list = this.list;
    var w = stepWidth(list);
    var first = items(list)[0];
    if (!first || !w) return;
    var left = list.scrollLeft;
    list.appendChild(first);
    setLeft(list, left - w);
  };

  Loop.prototype.rotateBackward = function () {
    var list = this.list;
    var w = stepWidth(list);
    var li = items(list);
    var last = li[li.length - 1];
    if (!last || !w) return;
    var left = list.scrollLeft;
    list.insertBefore(last, li[0]);
    setLeft(list, left + w);
  };

  // animate to an exact position with snapping switched off, so the
  // browser's scroll-snap cannot cancel the move
  Loop.prototype.animateTo = function (target) {
    var self = this;
    var list = this.list;
    self.busy = true;
    list.style.scrollSnapType = 'none';

    if (reduceMotion) {
      setLeft(list, target);
      finish();
      return;
    }

    var start = list.scrollLeft;
    var dist = target - start;
    var t0 = null;
    list.style.scrollBehavior = 'auto';

    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / ANIM_MS);
      var eased = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      list.scrollLeft = start + dist * eased;
      if (p < 1) requestAnimationFrame(frame);
      else finish();
    }
    requestAnimationFrame(frame);

    function finish() {
      list.style.scrollBehavior = '';
      list.style.scrollSnapType = '';
      self.busy = false;
    }
  };

  Loop.prototype.next = function () {
    if (this.busy) return;
    var list = this.list;
    var w = stepWidth(list);
    if (!w) return;
    if (list.scrollLeft + w > maxLeft(list) - 2) this.rotateForward();
    this.animateTo(Math.min(list.scrollLeft + w, maxLeft(list)));
  };

  Loop.prototype.prev = function () {
    if (this.busy) return;
    var list = this.list;
    var w = stepWidth(list);
    if (!w) return;
    if (list.scrollLeft - w < 1) this.rotateBackward();
    this.animateTo(Math.max(list.scrollLeft - w, 0));
  };

  Loop.prototype.bind = function () {
    var self = this;
    var list = this.list;
    var root = this.root;
    var settle = null;

    // manual swipes: keep cards on both sides so a swipe never hits a wall
    list.addEventListener('scroll', function () {
      if (self.busy) return;
      clearTimeout(settle);
      settle = setTimeout(function () {
        if (self.busy) return;
        var w = stepWidth(list);
        if (!w) return;
        if (list.scrollLeft >= maxLeft(list) - 2) self.rotateForward();
        else if (list.scrollLeft < 1 && self.touched) self.rotateBackward();
      }, 180);
    }, { passive: true });

    root.querySelectorAll('[data-mx-loop-prev]').forEach(function (b) {
      b.addEventListener('click', function () { self.prev(); self.restart(); });
    });
    root.querySelectorAll('[data-mx-loop-next]').forEach(function (b) {
      b.addEventListener('click', function () { self.next(); self.restart(); });
    });

    root.addEventListener('mouseenter', function () { self.paused = true; });
    root.addEventListener('mouseleave', function () { self.paused = false; });
    root.addEventListener('touchstart', function () { self.paused = true; self.touched = true; }, { passive: true });
    root.addEventListener('touchend', function () { setTimeout(function () { self.paused = false; }, 4000); }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? self.start() : self.stop(); });
      }, { threshold: 0.2 }).observe(list);
    } else {
      self.start();
    }
  };

  Loop.prototype.tick = function () {
    if (this.paused || document.hidden || !this.list.offsetParent) return;
    this.next();
  };

  Loop.prototype.start = function () {
    var self = this;
    if (!this.seconds || reduceMotion) return;
    this.stop();
    this.timer = setInterval(function () { self.tick(); }, this.seconds * 1000);
  };

  Loop.prototype.stop = function () {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  };

  Loop.prototype.restart = function () {
    if (this.timer) this.start();
  };

  function setup(list) {
    if (list.mxLoop || items(list).length < 2) return;
    list.mxLoop = new Loop(list);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-mx-loop]').forEach(setup);
  }

  window.MxLoop = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
